<template>
  <li class="km__list__element--modules"
      @click="$emit('show', tabToDisplay.id)"
      :class="{current:(tab_open)}"
      >
      {{ $t(tabToDisplay.textID) }}
  </li>
</template>

<script lang="ts" setup>
import {TabData} from "@km/data/tabs";
import {PropType} from "vue";

const props = defineProps({
  tabToDisplay: Object as PropType<TabData>,
  tab_open: Boolean
});
</script>

<style lang="scss" scoped>
@use "../../scss/settings/config" as config;

.km__modules__navi {
  .km__list__element--modules {
    display: flex;
    flex-direction: column;
    width: 25%;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    height: 40px;
    justify-content: center;

    &.current {
      background: config.$color-white;
    }
  }
}

</style>
